import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgBreakGlyphSecondary from './svgs/BreakGlyphSecondary.js';
import SvgBreakGlyph from './svgs/BreakGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var breakGlyph = (props => useIcon(SvgBreakGlyph, SvgBreakGlyphSecondary, props));

export { breakGlyph as default };
